import React, { useState } from 'react';
import classnames from 'classnames';

import { Button, Tooltip } from '../../../components';
import { plusIcon, trashIcon } from '../rule/rule-utils';

import './generic-row.scss';

interface GenericRowProps {
	className?: string;
	disabled?: boolean;

	isLast: boolean;
	addTooltipText: string;
	removeTooltipText?: string;

	children: (props: { setIsValid: (isValid: boolean) => void }) => React.ReactNode;

	onAdd(): void;

	onRemove(): void;
}

const GenericRow = ({
	isLast,
	onRemove,
	onAdd,
	addTooltipText,
	className,
	disabled = false,
	removeTooltipText,
	children
}: GenericRowProps) => {
	if (typeof children !== 'function') {
		throw new Error('children must be a function');
	}

	const [isValid, setIsValid] = useState(false);

	return (
		<div
			className={classnames('generic-row', 'sub-condition-row', className, {
				'disabled-sub-condition': disabled
			})}
		>
			{children({ setIsValid })}

			{isLast && (
				<Tooltip placement="top" title={addTooltipText}>
					<Button
						data-test-id="add-row"
						type="primary"
						shape="circle"
						className="add-button"
						icon={plusIcon}
						onClick={onAdd}
						disabled={!isValid}
					/>
				</Tooltip>
			)}

			<Tooltip placement="top" title={removeTooltipText}>
				<Button
					data-test-id="remove-row"
					shape="circle"
					className="remove-button generic-row-remove-button"
					icon={trashIcon}
					onClick={onRemove}
				/>
			</Tooltip>
		</div>
	);
};

export default GenericRow;
